import { resolveConfig, } from '@office-start/config-resolver-service';
export function getSharedContext(options) {
    return resolveConfig('sharedContext', options);
}
//# sourceMappingURL=getSharedContext.js.map